export const locales = [
    'ar-AE',
    'bn-IN',
    'cs-CZ',
    'da-DK',
    'de-DE',
    'en-AE',
    'en-AU',
    'en-CA',
    'en-GB',
    'en-IE',
    'en-IN',
    'en-SG',
    'en-US',
    'en-ZA',
    'es-ES',
    'es-MX',
    'es-US',
    'fr-BE',
    'fr-CA',
    'fr-FR',
    'he-IL',
    'hi-IN',
    'id-ID',
    'it-IT',
    'ja-JP',
    'kn-IN',
    'ko-KR',
    'ml-IN',
    'mr-IN',
    'nl-BE',
    'nl-NL',
    'pl-PL',
    'pt-BR',
    'pt-PT',
    'sv-SE',
    'ta-IN',
    'te-IN',
    'th-TH',
    'tr-TR',
    'zh-CN',
    'zh-TW',
];
